"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _reactIntl = require("react-intl");
var _AllOrOne = _interopRequireDefault(require("../../AllOrOne"));
var _Location = _interopRequireDefault(require("../Location"));
var _addresses = _interopRequireDefault(require("../../utils/addresses"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Locations = function Locations(_ref) {
  var className = _ref.className,
    clickableAddress = _ref.clickableAddress,
    hideLocationName = _ref.hideLocationName,
    isInNetworkGroup = _ref.isInNetworkGroup,
    locations = _ref.locations,
    originLatLng = _ref.originLatLng,
    showCount = _ref.showCount,
    showMore = _ref.showMore,
    locationAdditionalContentComponent = _ref.locationAdditionalContentComponent,
    intlProvider = _ref.intlProvider;
  var calculatedDistances = (0, _lodash.map)(locations, function (location) {
    return _addresses["default"].calculateDistance(location, originLatLng);
  });
  var formattedLocations = (0, _lodash.sortBy)(calculatedDistances, 'distanceVal') || [];
  var locationText;
  if (formattedLocations.length === 1) {
    locationText = !(0, _lodash.isEmpty)(intlProvider) ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UdrOGf",
      description: "location-singular",
      defaultMessage: "Location"
    }, function (txt) {
      return /*#__PURE__*/_react["default"].createElement("h4", {
        className: "ui-locations-header"
      }, "".concat(formattedLocations.length, " ").concat(txt));
    }) : /*#__PURE__*/_react["default"].createElement("h4", {
      className: "ui-locations-header"
    }, "".concat(formattedLocations.length, " Location"));
  } else {
    locationText = !(0, _lodash.isEmpty)(intlProvider) ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "NRZ/fl",
      description: "location-plural",
      defaultMessage: "Locations"
    }, function (txt) {
      return /*#__PURE__*/_react["default"].createElement("h4", {
        className: "ui-locations-header"
      }, "".concat(formattedLocations.length, " ").concat(txt));
    }) : /*#__PURE__*/_react["default"].createElement("h4", {
      className: "ui-locations-header"
    }, "".concat(formattedLocations.length, " Locations"));
  }
  if ((0, _lodash.isEmpty)(formattedLocations)) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-locations ".concat(className)
  }, showCount && locationText, /*#__PURE__*/_react["default"].createElement(_AllOrOne["default"], {
    showAll: showMore
  }, formattedLocations.map(function (location) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "ui-location__container mb-half pt-half pb-half",
      key: location.id || (0, _lodash.uniqueId)(location.name || location.displayName)
    }, /*#__PURE__*/_react["default"].createElement(_Location["default"], {
      clickableAddress: clickableAddress,
      hideLocationName: hideLocationName,
      isInNetworkGroup: isInNetworkGroup,
      location: location,
      originLatLng: originLatLng,
      showMore: showMore,
      additionalContentComponent: locationAdditionalContentComponent,
      intlProvider: intlProvider
    }));
  })));
};
Locations.propTypes = {
  className: _propTypes["default"].string,
  clickableAddress: _propTypes["default"].bool,
  hideLocationName: _propTypes["default"].bool,
  isInNetworkGroup: _propTypes["default"].bool,
  locations: _propTypes["default"].array,
  originLatLng: _propTypes["default"].array,
  showCount: _propTypes["default"].bool,
  showMore: _propTypes["default"].bool,
  /**
   * Property passed down to location component that will render in the main content area of the component.
   * This feature is used to render an edit location link.
   */
  locationAdditionalContentComponent: _propTypes["default"].func,
  intlProvider: _propTypes["default"].object
};
Locations.defaultProps = {
  className: '',
  clickableAddress: false,
  hideLocationName: false,
  isInNetworkGroup: true,
  locations: [],
  originLatLng: [],
  showCount: true,
  showMore: false,
  locationAdditionalContentComponent: null,
  intlProvider: {}
};
var _default = exports["default"] = Locations;